module.exports = __webpack_public_path__ + "static/media/Minerva_LogoColor.a0fa92dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Minerva_LogoColor.svg
// module id = 1260
// module chunks = 0